import styled from 'styled-components'
import {
  FONT_SIZE,
  COLOR
} from '../../themes'
const Style = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: stretch;
  align-items: center;
  padding: 0;
  margin: 0;
  line-height: 36px;
  .input-box {
    flex: 3;
    border-radius: 3px;
    border: 1px solid ${COLOR.GRAY_6};
    display: flex;
    flex-flow: row nowrap;
    justify-content: stretch;
    align-items: center;
    padding: 0;
    margin: 0;
  }
  .button-container {
    display: flex;
    flex-flow: column nowrap;
    justify-content: stretch;
    align-items: stretch;
    height: 100%;
    width: 10px;
    padding: 0 10px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .button-container > svg {
    cursor: pointer;
  }
  .button-container > svg:hover {
    color: ${COLOR.BLACK_1};
  }
  .button-container > svg:focus {
    color: ${COLOR.BLACK_1};
  }
  .button-container > svg:active {
    color: ${COLOR.BLACK_1};
  }
  label {
    height: 100%;
    font-size: ${FONT_SIZE.TN};
    flex: 1;
    padding: 0;
    margin: 0;
    margin-left: 12px;
  }
  .disabled,
  .disabled * {
    background-color: ${COLOR.GRAY_2} !important;
    cursor: not-allowed !important;
  }
`

export default Style
